import React, { useState, useEffect } from 'react';
import Modal from '../../Modal/Modal';
import Config from '../StructureComponents/Config';
import getPostBySlug from '../../../api/graphql/queries/getPostBySlug';

const PostInformationBox = ({
  post, toggleRefetch, sendPost, selectedOnDragAndDrop, addStatusMessage, templateType, updatePost
}) => {
  const {
    slugName, postDescription, postDescription: { url }, type, postName,
  } = post;
  const PUBLIC_ROUTE = process.env.PUBLIC_ROUTE || '';
  console.log("🚀 ~ PostInformationBox ~ PUBLIC_ROUTE:", PUBLIC_ROUTE)
  const [isModalOn, setModalState] = useState(false);
  const [infoIsOpen, setInfoIsOpen] = useState(true);
  const toggleModal = () => {
    setModalState(!isModalOn);
  };

  return (
    <>
      <div className="bg-black text-white rounded p-5 mb-2">
        <h3 onClick={() => { setInfoIsOpen(!infoIsOpen); }} className={`${infoIsOpen ? 'border-b border-greyWithinForm text-greyText pb-4' : 'text-white'} font-americaMonoRegular uppercase text-sm pt-1 flex flex-row justify-between`}>
          {type !== 'component' ? 'Page information' : 'Reusable module'}
          {' '}
          <span className={`${infoIsOpen ? 'icon-arrow-down text-greyWithinForm' : 'icon-arrow-up text-white'} font-icon text-greyText text-xxs font-bold`} />
        </h3>
        {infoIsOpen && (
          <div>
            <div className="border-greyWithinForm border-b-1" />
            {type !== 'component' ? (
              <>
                <p className="font-americaMonoRegular uppercase mt-4 mb-2 text-greyFilter text-12">Page title</p>

                {postDescription && postDescription.title.en
                && <h2 className="mt-0 mb-4 pt-0 text-base font-americaBlack text-greyFilter">{postDescription.title.en}</h2>}
                <p className="font-americaMonoRegular uppercase m-0 mb-2 mt-4 text-greyFilter text-12">Page url</p>
                {slugName && <p className="font-americaBlack mt-0 pr-4 text-sm break-all text-greyFilter">{`${PUBLIC_ROUTE}${url || `/${slugName}`}`}</p>}

              </>
            )
              : (
                <>
                  <p className="font-americaMonoRegular uppercase mt-4 mb-2 text-greyFilter text-12">Module name</p>
                  {postName
          && <h2 className="mt-0 mb-4 pt-0 text-base font-americaBlack text-greyFilter">{postName}</h2>}
                  <p className="font-americaMonoRegular uppercase m-0 mb-2 mt-4 text-greyFilter text-12">Slugname</p>
                  {slugName && <p className="font-americaBlack mt-0 pr-4 text-sm break-all text-greyFilter">{slugName}</p>}
                </>
              )}
            <button
              className="mr-2 font-americaMonoBold text-xs pl-7 bg-black border border-white rounded-full uppercase text-white h-8 items-center pb-1 pr-5 mb-3"
              type="button"
              onClick={() => {
                toggleModal();
              }}
            >
              Edit
              {' '}
              <span className="font-icon icon-edit text-white text-sm" />
            </button>
          </div>
        )}
      </div>
      {' '}
      {isModalOn && (
        <Modal handleClick={toggleModal} positionMiddle size="w-89% xxl1:94%" background="pb-4 px-0 scrollbar__grey">
          <div>
            <Config
              currentPost={post}
              updatePost={updatePost}
              addStatusMessage={addStatusMessage}
              closeModal={toggleModal}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default PostInformationBox;
